import api from './api';
import type { AvailabilityResponse, BookingCreateResponse, BookingRecord, BookingStatus, AvailableDateConfig } from '../types';

export interface SetAvailableDateInput {
  date: string;
  times: string[];
}

export const bookingApi = {
  /** Fetches all admin-configured available dates and times in a single call. */
  getAvailableDates: async (): Promise<AvailableDateConfig[]> => {
    return api.get('bookings/available-dates').json<AvailableDateConfig[]>();
  },

  /** Admin: replaces available dates and times with the given list. */
  setAvailableDates: async (dates: SetAvailableDateInput[]): Promise<AvailableDateConfig[]> => {
    return api.put('bookings/available-dates', { json: { dates } }).json<AvailableDateConfig[]>();
  },

  getAvailability: async (date: string, durationMinutes: number): Promise<AvailabilityResponse> => {
    return api.get('bookings/availability', {
      searchParams: { date, durationMinutes },
    }).json<AvailabilityResponse>();
  },

  createBooking: async (bookingData: {
    serviceId: string;
    serviceName: string;
    customerName: string;
    email: string;
    phone: string;
    company?: string;
    startAt: string;
    endAt: string;
    timezone: string;
    calendarProvider: string;
    locale: string;
    notes?: string;
  }): Promise<BookingCreateResponse> => {
    return api.post('bookings', { json: bookingData }).json<BookingCreateResponse>();
  },

  listBookings: async (): Promise<BookingRecord[]> => {
    return api.get('bookings').json<BookingRecord[]>();
  },

  getMyBookings: async (): Promise<BookingCreateResponse[]> => {
    return api.get('bookings/my').json<BookingCreateResponse[]>();
  },

  updateBookingStatus: async (bookingId: string, status: BookingStatus): Promise<BookingRecord> => {
    return api.patch(`bookings/${bookingId}/status`, { json: { status } }).json<BookingRecord>();
  },
};
